module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAARCAMAAAD9uOxFAAAAUVBMVEUAAAAEAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB0EAB2JJyXCAAAAGnRSTlMAoLDuCLWchWnDwKeYdBUP+tDPlY58b15ZV9PevXcAAABaSURBVCjPfdE3AoNAEATBkU5wCO9N//+hBKTsVNrRzupVWfcyEtNg8gn/n+kVFK5v0MhYYZFRQpaOT2SEXQkjqfoGCqBTqIWsUIZWoc7e7Ve7/OaJedDD/vsG1jQHv7rji5wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/jiantou.png
// module id = U8AV
// module chunks = 1